export default __webpack_public_path__ + "static/media/asahi_markets_whitelogo.f48d44ce.svg";